import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type MaliciousCardCoverAttachmentFragment = (
  { __typename: 'Card' }
  & Pick<Types.Card, 'id' | 'idAttachmentCover'>
  & { attachments: Array<(
    { __typename: 'Attachment' }
    & Pick<Types.Attachment, 'id' | 'isMalicious'>
  )> }
);

export const MaliciousCardCoverAttachmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MaliciousCardCoverAttachment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Card' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isMalicious' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'idAttachmentCover' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseMaliciousCardCoverAttachmentFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      MaliciousCardCoverAttachmentFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseMaliciousCardCoverAttachmentFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<MaliciousCardCoverAttachmentFragment>,
    'data'
  > {
  data?: MaliciousCardCoverAttachmentFragment;
}

export const useMaliciousCardCoverAttachmentFragment = ({
  from,
  returnPartialData,
  ...options
}: UseMaliciousCardCoverAttachmentFragmentOptions): UseMaliciousCardCoverAttachmentFragmentResult => {
  const result = Apollo.useFragment<MaliciousCardCoverAttachmentFragment>({
    ...options,
    fragment: MaliciousCardCoverAttachmentFragmentDoc,
    fragmentName: 'MaliciousCardCoverAttachment',
    from: {
      __typename: 'Card',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return {
    ...result,
    data: result.data as MaliciousCardCoverAttachmentFragment,
  };
};
